import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-process",
  "use": "icon-process-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-process\"><path d=\"M960 480H615.8L512 376.2 408.2 480H128V224h160v96h640V64H288v96H64v384h344.2L512 647.8 615.8 544H896v256H768v-96H128v256h640v-96h192V480zM352 128h512v128H352V128z m352 768H192V768h512v128z\" fill=\"#8a8a8a\" p-id=\"26045\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol